<template>
    <div class="footer bg-dark1 py-5">
        <div class="container row mx-auto">
            <div class="row pt-4">
                <img src="../assets/img/logo/logo-name-white.svg" style="width: 150px;" alt="">
            </div>
            <hr style="">
            <div class="col-xl-8 row">
                <div class="col-lg-6">
                    <div style="font-size: 16px;font-weight: bold" class="my-3">Reach us</div>
                    <div class="my-3" style="cursor: pointer;font-size: 13px"><FontAwesomeIcon icon="fa-solid fa-phone-volume"/><span class="d-inline mx-3">+971543737505</span></div>
                    <div class="my-3" style="cursor: pointer;font-size: 13px"><FontAwesomeIcon icon="fa-solid fa-envelope" /><span class="d-inline mx-3">info@heyvaai.com</span></div>
                    <div class="my-3" style="cursor: pointer;font-size: 13px"><FontAwesomeIcon icon="fa-solid fa-location-dot" /><span class="d-inline mx-3">HEIRS OF AHMED OBAID BIN TOUQ AL MARRI BUILDING, No.304- A 2, Al Mararr, Dubai, United Arab Emirates</span></div>
                </div>
                <div class="row col-lg-6 my-lg-0 my-4 mx-auto">
                    <div class="col-6 px-0">
                        <div style="font-size: 16px;font-weight: bold" class="my-3" @click="router.push({'name':'demo'})">Company</div>
                        <div style="cursor: pointer;font-size: 13px"  class="my-2" @click="router.push({'name':'about'})">About</div>
                        <div style="cursor: pointer;font-size: 13px"  class="my-2" @click="router.push({'name':'contact'})">Contact</div>
                        <div style="cursor: pointer;font-size: 13px"  class="my-2" @click="router.push({'name':'blogs'})">Blog</div>
                        <div style="cursor: pointer;font-size: 13px"  class="my-2" @click="router.push({'name':'faq'})">Faq</div>
                    </div>
                    <div class="col-6 px-0">
                        <div style="font-size: 16px;font-weight: bold" class="my-3">Quick Links</div>
                        <div style="cursor: pointer;font-size: 13px"  class="my-2" >Chatbot</div>
                        <div style="cursor: pointer;font-size: 13px"  class="my-2" >QC</div>
                        <div style="cursor: pointer;font-size: 13px"  class="my-2" >MCI</div>
                    </div>
                </div>
            </div>
            <div class="col-xl-4">
                <div class="light-card mx-auto row">
                    <h6>Join Our Newsletter</h6>
                    <div class="col-sm-9 d-inline">
                        <input type="text" class="footer-input mx-2 w-100">
                    </div>
                    <div class="col-sm-3 mt-sm-0 mt-2">
                        <button class="footer-button">submit</button>
                    </div>
                    <span style="font-size: 12px;color: #ffffff93" class="d-block w-100 mt-2">*  Will send you weekly updates for your better tool management.</span>
                    <div class="col-12 mt-3">
                        <span style="font-size: 12px;color: #ffffff93" class="d-block w-100 text-nowrap">Question & answers</span>
                        <div class="row mt-2">
                            <div class="col-sm-4 col-6"><div class="footer-input w-100 text-center">9 + 3</div></div>
                            <div class="col-sm-4 col-6"><input type="text" class="footer-input w-100"></div>
                            <div class="col-sm-4 mt-sm-0 mt-2"><button class="footer-button">submit</button></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 text-end mt-3">
                <a href="https://www.instagram.com/heyvaai?igsh=dzI4eXZkdzNrN3Fl"><FontAwesomeIcon style="color: white;" class="m-2 fs-5" icon="fa-brands fa-instagram"/></a>
                <a href="https://www.linkedin.com/company/heyvaai"><FontAwesomeIcon style="color: white;" class="m-2 fs-5" icon="fa-brands fa-linkedin"/></a>
            </div>
        </div>
    </div>
</template>
<script>
import { defineComponent } from '@vue/composition-api';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faPhoneVolume, faEnvelope, faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { library } from '@fortawesome/fontawesome-svg-core';
import { useRouter } from 'vue-router';
import { faInstagram,faLinkedin } from '@fortawesome/free-brands-svg-icons';

export default defineComponent({
    components:{FontAwesomeIcon},
    setup(){
        const router = useRouter()
        library.add(faPhoneVolume,faEnvelope,faLocationDot,faInstagram,faLinkedin);

        return{router}
    }
})
</script>
<style scoped lang="scss">
.light-card{
    background-color: #ffffff0e;
    border: none;
    border-radius: 10px;
    padding: 15px;
}
.footer-input {
    background-color: #ffffff11;
    border: none;
    outline-style: none;
    border-radius: 5px;
    color: white;
    padding: 5px 10px;
}
.footer-button {
    background-color: #000;
    border: none;
    border-radius: 5px;
    color: white;
    padding: 5px 10px;
}
</style>